var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "social-twitter-footer-fix",
    "data-name": "f91d7e40-91f4-4494-bd0c-a3bb0e9b73ce",
    viewBox: "0 0 160 160",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M148.82,37.25a58.33,58.33,0,0,1-16.18,4.46,28.72,28.72,0,0,0,12.45-15.66,55.26,55.26,0,0,1-18,6.89A28.29,28.29,0,0,0,79,58.72a80.28,80.28,0,0,1-58.3-29.57,28.33,28.33,0,0,0,8.83,37.79,27.34,27.34,0,0,1-12.76-3.53v.31a28.23,28.23,0,0,0,22.62,27.7,29.24,29.24,0,0,1-12.76.52A28.26,28.26,0,0,0,53,111.53a57,57,0,0,1-41.81,11.62,80.2,80.2,0,0,0,43.24,12.79c52,0,80.4-43,80.4-80.4,0-1.24,0-2.49-.1-3.63A54.06,54.06,0,0,0,148.82,37.25Z",
    fill: "#ffffff",
    stroke: "none"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/twitter.ba664508.svg";
export { ForwardRef as ReactComponent };